
import Accelerating from './Accelerating.vue'
import PoweredBy from './PoweredBy.vue'
import WorksAnywhere from './WorksAnywhere.vue'

export default {
  components: { Accelerating, PoweredBy, WorksAnywhere },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
